import { Header } from '@widgets/header';
import { NavLeftCenter, NavRight } from '@features/shop';
import { PageHead } from '@shared/ui';
import { useProduct } from '@src/library/hooks/shop';

export const ShopListHead = () => {
  const { productId } = useProduct();

  const whatPage =
    (location.pathname.indexOf('video') !== -1 && 'Видео') ||
    (location.pathname.indexOf('specification') !== -1 && 'Характеристики') ||
    (location.pathname.indexOf('description') !== -1 && 'Описание') ||
    (location.pathname.indexOf('product/') !== -1 && 'Товар') ||
    (location.pathname.indexOf('order/') !== -1 && 'Информация о заказе') ||
    (location.pathname.indexOf('search') !== -1 && 'Поиск') ||
    'Магазин';

  const comeBack =
    ((whatPage === 'Видео' || whatPage === 'Характеристики' || whatPage === 'Описание') &&
      `/shop/store/products/product/${productId}`) ||
    (whatPage === 'Товар' && `/shop/store/products`) ||
    (whatPage === 'Поиск' && `/shop/store/products`) ||
    (whatPage === 'Информация о заказе' && `/shop/store/orders`) ||
    undefined;

  return (
    <>
      <Header MCenter={<>Магазин</>} />
      {whatPage === 'Магазин' && (
        <>
          <PageHead Left={<NavLeftCenter page="main" />} Right={<NavRight />} />
        </>
      )}

      {whatPage === 'Поиск' && (
        <PageHead
          Left={<NavLeftCenter comeBackButton={comeBack} />}
          Center={whatPage}
          Right={<NavRight />}
        />
      )}
      {whatPage !== 'Магазин' && whatPage !== 'Поиск' && (
        <PageHead
          Center={whatPage}
          Left={<NavLeftCenter comeBackButton={comeBack} />}
          Right={<NavRight />}
        />
      )}
    </>
  );
};
